// One synchronous publication boundary shared by prepared UI participants.
// All guards are checked before the first setter; no network work belongs here.
export function createPublicationStateTransaction() {
    const entries = [];
    let closed = false;
    let transferred = false;
    const canCommit = (isCurrent = null) => !closed
        && (typeof isCurrent !== 'function' || isCurrent())
        && entries.every(entry => entry.isCurrent());
    return {
        stage(apply, isCurrent = null) {
            if (closed || transferred || typeof apply !== 'function') return;
            entries.push({ apply, isCurrent: typeof isCurrent === 'function' ? isCurrent : () => true });
        },
        canCommit,
        transferTo(stage) {
            if (closed || transferred || typeof stage !== 'function') return false;
            transferred = true;
            entries.forEach(({ apply, isCurrent }) => stage(apply, isCurrent));
            // The root transaction preflights every participant before writes;
            // do not recheck old baseline guards after our own version setters.
            stage(() => { closed = true; entries.length = 0; }, () => !closed);
            return true;
        },
        commit(isCurrent = null) {
            if (transferred) return false;
            if (!canCommit(isCurrent)) {
                closed = true;
                entries.length = 0;
                return false;
            }
            closed = true;
            const updates = entries.splice(0);
            updates.forEach(({ apply }) => apply());
            return true;
        },
        discard() {
            closed = true;
            entries.length = 0;
        },
    };
}
